var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.asignados),function(a){return _c('div',{staticClass:"column is-3"},[_c('CardArticulo_Asign',{key:a.id,attrs:{"articulo":a,"disabled":_vm.getIsDisabled(a)},on:{"asignarArticulo":_vm.selectArticulo}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39fb1c8a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventario_Componentes/ListAsignaciones.vue
// module id = 2530
// module chunks = 0